import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const EmailAlreadyTakenError = BaseErrorSchema.extend({
  errorType: z.literal('EmailAlreadyTakenError'),
  email: z.string(),
});

export type EmailAlreadyTakenError = z.infer<typeof EmailAlreadyTakenError>;
